import { defaultMessages } from './lib/intl/defaultMessages';
import { defaultMessagesFR } from './lib/intl/fr-CA';

export const programId = '5ede44261f1bfb1aac1b4fcf';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    useFingerprinting: true,
    logLevel: 'error',
    messagesWithLocale: {
        'en-US': defaultMessages,
        'fr-CA': defaultMessagesFR,
    },
};
